module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="task-panel">\n    <div class="taskHeader"></div>\n    <div class="taskBody">\n        <div class="recordContainer"></div>\n        <div class="launch-button"></div>\n        <div class="viewContainer">\n        </div>\n        <div class="tabbar"></div>\n    </div>\n</div>';

}
return __p
}